"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../helpers/customPropTypes");

var _propTypes3 = require("./propTypes");

var _ToggleItem = require("./ToggleItem");

var _ToggleItem2 = _interopRequireDefault(_ToggleItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_Component) {
  _inherits(Toggle, _Component);

  function Toggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (clickedId) {
      var _this$props = _this.props,
          selectedItemIds = _this$props.selectedItemIds,
          onChange = _this$props.onChange,
          onSelect = _this$props.onSelect,
          onDeselect = _this$props.onDeselect;

      var itemIndex = selectedItemIds.indexOf(clickedId);
      var itemUsedToBeSelected = itemIndex > -1;

      if (onChange) {
        var newSelectedItemIds = [].concat(_toConsumableArray(selectedItemIds));

        if (itemUsedToBeSelected) {
          newSelectedItemIds.splice(itemIndex, 1);
        } else {
          newSelectedItemIds.push(clickedId);
        }

        onChange(newSelectedItemIds);
      }

      if (onDeselect && itemUsedToBeSelected) {
        onDeselect(clickedId);
      } else if (onSelect && !itemUsedToBeSelected) {
        onSelect(clickedId);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Toggle, [{
    key: "listItems",
    value: function listItems() {
      var _this2 = this;

      var _props = this.props,
          icon = _props.icon,
          isDisabled = _props.isDisabled,
          isFullWidth = _props.isFullWidth,
          items = _props.items,
          selectedItemIds = _props.selectedItemIds,
          selectedColor = _props.selectedColor,
          size = _props.size;


      return items.map(function (item) {
        var isSelected = selectedItemIds.indexOf(item.value) > -1;

        return _react2.default.createElement(_ToggleItem2.default, {
          icon: icon,
          isDisabled: isDisabled,
          isFullWidth: isFullWidth,
          isSelected: isSelected,
          item: item,
          key: item.value,
          onClick: _this2.handleClick,
          selectedColor: selectedColor,
          size: size
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          isFullWidth = _props2.isFullWidth,
          size = _props2.size,
          uppercase = _props2.uppercase;

      var rootClasses = (0, _classnames2.default)("aclui-toggle", className, "aclui-toggle--" + size, {
        "aclui-toggle--is-full-width": isFullWidth,
        "aclui-toggle--is-uppercase": uppercase
      });

      return _react2.default.createElement(
        "div",
        { className: rootClasses, role: "listbox", "aria-orientation": "horizontal" },
        this.listItems()
      );
    }
  }]);

  return Toggle;
}(_react.Component);

Toggle.propTypes = {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  isFullWidth: _propTypes2.default.bool,
  items: _propTypes2.default.arrayOf(_propTypes3.shapeOfItem).isRequired,
  onChange: _propTypes2.default.func,
  onDeselect: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  selectedColor: _propTypes3.oneOfColorType,
  selectedItemIds: _propTypes2.default.arrayOf(_propTypes3.itemValueType),
  size: _customPropTypes.shirtSize,
  uppercase: _propTypes2.default.bool
};

Toggle.defaultProps = {
  className: null,
  icon: false,
  isDisabled: false,
  isFullWidth: false,
  onChange: null,
  onDeselect: null,
  onSelect: null,
  selectedColor: "green",
  selectedItemIds: [],
  size: "small",
  uppercase: true
};

exports.default = Toggle;